import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {BaseScaffoldComponent} from '@scaffold/view/rendered/components/base-scaffold/base-scaffold.component';
import {RenderedService} from '@scaffold/view/rendered/rendered.service';
import { NbSortDirection, NbSortRequest, NbTreeGridDataSource, NbTreeGridDataSourceBuilder, NbDialogService } from '@nebular/theme';
import { CommentingService } from '@scaffold/services/commenting.service';
import { take } from 'rxjs/operators';
import { ViewModalComponent } from '@scaffold/dialogs/view-modal/view-modal.component';
import { Router } from '@angular/router';
import { CommentSidebarComponent } from '@app/commenting/comment-sidebar/comment-sidebar.component';
import { ScaffoldSidebarService } from '@services/scaffold-sidebar.service';


interface TreeNode<T> {
  data: T;
  children?: TreeNode<T>[];
  expanded?: boolean;
}

interface FSEntry {
  name: string;
  title: string;
  item?: string;
}

@Component({
  selector: 'app-mentions',
  templateUrl: './mentions.component.html',
  styleUrls: ['./mentions.component.scss']
})

export class MentionsComponent extends BaseScaffoldComponent implements OnInit {


  dialogRef;
  allColumns = [ 'name', 'title', 'item' ];
  saturation = 60;
  level = 80;
  // @ts-ignore
  data = [

  ];

  constructor(public cdr: ChangeDetectorRef, public renderedService: RenderedService, private commentor: CommentingService, private router: Router, public dialog: NbDialogService,
    private commentSidebar: ScaffoldSidebarService) { super(cdr, renderedService); }

  ngOnInit() {
    this.commentor.userMentions().pipe(take(1)).subscribe(req => {
      this.data = req.mentions;
      this.update();
    })
  }

  stringToHslColor(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    var h = hash % 360;
    return 'hsl(' + h + ', ' + this.saturation + '%, ' + this.level + '%)';
  }

  open(e: Event, item) {
    e.preventDefault();
    if (item?.target) {
      this.openComments(item);
    /*  if (item.target.type = 'courses') {
        this.router.navigate([item.target.type, item.target.id], {});
      } else if (item.target.parent_type = 'courses') {
        this.router.navigate([item.target.parent_type, item.target.parent_id, item.target.type, item.target.id], {});
      }else {
        this.openViewHandler('read',item.target)
      }*/
    }
  }

  openComments(item) {
    let config = {
      context: {
        item: item.name,
        info: item.target,
        label: this.getCommentTitle(item)
      }
    }
  
    let _sidebar = this.commentSidebar.open(CommentSidebarComponent, config);

  }

  getCommentTitle(item) {
    let title = "";
    if (item.target.title) {
      title += item.target.title + " ";
    }
    if (item.target.parent_type = 'courses' && item.target.parent_title) {
      title += "(" + item.target.parent_title + ") ";
    }
    title += item.name || item.key
    return title;
  }

  openViewHandler(mode: any, item: any) {
    let settings: any = {
      context: {
        data: {
          mode: mode,
          item: item || this.info.children || this.info,
          //   parent: parent || this.info
        }
      }
    };
    this.dialogRef = this.dialog.open(ViewModalComponent, settings);
    this.dialogRef.onClose.subscribe(result => {
      console.log(result);
      console.log(this.item);
      console.log(this.info);
      if (result && (result !== 'string' || result.length > 0)) {
        if (this.item && this.item.list_view) {


        }
      }
    });
  }
}
